import { useEffect, useState } from "react";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { ColorPreview } from "./common/ColorPreview";
import { ErrorBox } from "./common/ErrorBox";
import { useFormContext } from "react-hook-form";

export const ColorPicker = ({
  name,
  label,
  title,
  detailed_label,
  options,
  validation,
  errors,
  selectedColor
}) => {
  //const [selectedColor, setSelectedColor] = useState(null);
  console.log("re-render colorpicker");

  const { register, setValue, trigger } = useFormContext();
 
  /*
  useEffect(()=>{
    if(selectedColor){ // avoid first time render
      setValue(name, selectedColor,{ shouldValidate: true });  
    } 
  },[selectedColor])
*/
  const handleColorClick = (code) => {
    //setSelectedColor(code); // Update de geselecteerde kleur
    setValue(name, code,{ shouldValidate: true });  
  };

  return (
    <div className={`space-y-2`}>
      <div className="flex justify-between">
        <h1 className="text-2xl uppercase text-blue-600 font-semibold dark:text-white">
          {title}
        </h1>
        <AiOutlineInfoCircle className="text-orange-400 text-xl" />
      </div>

      <p className="text-sm font-medium">{detailed_label}</p>
      <div className="grid grid-cols-[repeat(auto-fill,minmax(70px,1fr))] gap-4">
        {options.map((color, i) => (
          <div key={i} className="flex flex-col items-center m-1">
            <ColorPreview
              color={color.color}
              diameter={60}
              code={color.code}
              label={color.label}
              handleColorClick={handleColorClick}
              key={i}
              selected={selectedColor == color.code}
            />
            <label className="text-xs mt-2 text-center">{color.label}</label>
          </div>
        ))}
      </div>

      <input type="hidden" {...register(name, {
  required: "Color is required",
})} />

      <ErrorBox errors={errors} />
    </div>
  );
};
